import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Checkbox, FormControlLabel } from "@mui/material";
import { Gavel } from "@mui/icons-material";

const DARK = 'var(--lm-bg-1a1f2b)';
const BORDER = 'rgba(var(--th-6c4f9b-rgb), 0.4)';

export default function CreatorTermsModal({ show, onAccept, onDecline, busy }) {
    const [checked, setChecked] = useState(false);

    const handleDecline = () => {
        setChecked(false);
        onDecline();
    };

    return (
        <Modal show={show} onHide={handleDecline} centered size="lg" data-bs-theme="dark" enforceFocus={false} backdrop="static">
            <Modal.Header style={{ backgroundColor: DARK, borderBottom: `1px solid ${BORDER}` }}>
                <Gavel style={{ height: 24, width: 24, marginRight: 8, color: 'var(--lm-tx-th-c9a0f0)' }} />
                <Modal.Title style={{ color: 'var(--lm-tx-f5f5f5)', fontSize: '1rem' }}>Creator Terms of Service</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '55vh', overflowY: 'auto', color: 'var(--lm-tx-th-e4e0ec)', fontSize: '0.85rem', lineHeight: 1.6 }}>
                <p>
                    Before you publish content to the DropWyrm Hoard, please read and agree to the
                    following. This governs any map, token, or other asset you publish as a Creator.
                </p>

                <h6 style={{ color: 'var(--lm-tx-f5f5f5)', marginTop: 16 }}>1. Ownership &amp; License</h6>
                <p>
                    You must own or have the necessary rights to any content you publish. By publishing, you grant
                    DropWyrm a non-exclusive, worldwide, royalty-free license to host, display, and distribute
                    your content to other users through the Hoard. You retain ownership of your original work.
                </p>

                <h6 style={{ color: 'var(--lm-tx-f5f5f5)', marginTop: 16 }}>2. Content Standards</h6>
                <p>
                    Published content must not infringe on any third party's copyright, trademark, or other
                    intellectual property rights, and must not contain explicit, illegal, or hateful material.
                    Uploaded images are automatically scanned, but you are solely responsible for what you publish.
                </p>

                <h6 style={{ color: 'var(--lm-tx-f5f5f5)', marginTop: 16 }}>3. Moderation</h6>
                <p>
                    Other users can report listings that appear to violate these terms. DropWyrm moderators may
                    hide or permanently remove any listing, at their discretion, without prior notice, and may
                    suspend a Creator's publishing privileges for repeated or serious violations.
                </p>

                <h6 style={{ color: 'var(--lm-tx-f5f5f5)', marginTop: 16 }}>4. No Compensation</h6>
                <p>
                    The Hoard is currently a free, community-driven catalog. Publishing content does not
                    entitle you to payment, royalties, or revenue share of any kind.
                </p>

                <h6 style={{ color: 'var(--lm-tx-f5f5f5)', marginTop: 16 }}>5. Removal</h6>
                <p>
                    You may remove your own listings at any time. Removing a listing does not retroactively revoke
                    copies already downloaded by other users prior to removal.
                </p>

                <h6 style={{ color: 'var(--lm-tx-f5f5f5)', marginTop: 16 }}>6. As-Is, No Warranty</h6>
                <p>
                    Content is provided "as-is" by its Creator. DropWyrm makes no warranty as to the accuracy,
                    quality, or fitness of any Hoard content.
                </p>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: DARK, borderTop: `1px solid ${BORDER}`, flexDirection: 'column', alignItems: 'stretch', gap: 8 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checked}
                            onChange={e => setChecked(e.target.checked)}
                            disabled={busy}
                            sx={{ color: 'var(--lm-tx-9e9e9e)', '&.Mui-checked': { color: 'var(--lm-tx-th-c9a0f0)' } }}
                        />
                    }
                    label={<span style={{ color: 'var(--lm-tx-f5f5f5)', fontSize: '0.82rem' }}>I have read and agree to the Creator Terms of Service.</span>}
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <Button onClick={handleDecline} disabled={busy} sx={{ color: 'var(--lm-tx-f5f5f5)', textTransform: 'none' }}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained" disabled={!checked || busy} onClick={onAccept}
                        sx={{ backgroundColor: 'var(--th-6c4f9b)', textTransform: 'none', '&:hover': { backgroundColor: 'var(--th-7c5fab)' } }}
                    >
                        {busy ? 'Accepting…' : 'Agree & Continue'}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
